import { Facebook, Twitter, Youtube, Instagram } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const Pinterest = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.08 2.46 7.58 6 9.13-.08-.78-.16-1.98.03-2.83.17-.73 1.1-4.66 1.1-4.66s-.28-.56-.28-1.39c0-1.3.75-2.27 1.69-2.27.8 0 1.18.6 1.18 1.31 0 .8-.51 2-.77 3.11-.22.93.46 1.68 1.37 1.68 1.65 0 2.92-1.74 2.92-4.25 0-2.22-1.6-3.78-3.88-3.78-2.64 0-4.2 1.98-4.2 4.03 0 .8.31 1.66.69 2.12.08.09.09.17.07.27-.07.3-.24.95-.27 1.08-.04.18-.14.21-.32.13-1.19-.55-1.94-2.29-1.94-3.69 0-3 2.18-5.76 6.29-5.76 3.3 0 5.87 2.35 5.87 5.5 0 3.28-2.07 5.92-4.94 5.92-.96 0-1.87-.5-2.18-1.09l-.59 2.26c-.21.83-.79 1.86-1.17 2.49.88.27 1.82.42 2.79.42 5.52 0 10-4.48 10-10S17.52 2 12 2z" />
  </svg>
);

const SOCIALS = [
  { icon: Facebook, href: "https://facebook.com/hpvcjackson", label: "Facebook" },
  { icon: Twitter, href: "https://x.com/HpvcJackson", label: "X" },
  { icon: Youtube, href: "https://www.youtube.com/@hydeparkvictorychurch7384", label: "YouTube" },
  { icon: Instagram, href: "https://instagram.com/hpvcjackson", label: "Instagram" },
  { icon: Pinterest, href: "https://pinterest.com/hpvcjackson", label: "Pinterest" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-12">
          <div>
            <button
              data-testid="footer-logo"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex items-center gap-2 group mb-6"
            >
              <img src="/hpvc-logo.png" alt="Hyde Park Victory Church logo" className="w-12 h-12 object-contain transition-transform duration-300 group-hover:scale-105" />
              <span className="font-display font-semibold uppercase tracking-tight text-2xl leading-none">
                Hyde Park <span className="text-[#4169E1]">Victory</span> Church
              </span>
            </button>
            <p className="text-sm text-zinc-500 max-w-sm leading-relaxed">
              A place where victory becomes a way of life. 6810 Presidential Drive, Jackson, MS 39213.
            </p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-6">
            <div className="flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-zinc-400 hover:text-white hover:border-[#4169E1] hover:bg-[#4169E1]/10 transition-colors duration-300"
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <button
              data-testid="footer-back-to-top"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-xs uppercase tracking-[0.3em] text-zinc-500 hover:text-[#4169E1] transition-colors duration-300"
            >
              Back to top
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-zinc-600">&copy; {new Date().getFullYear()} Hyde Park Victory Church. All rights reserved.</p>
          <button
            data-testid="footer-contact-link"
            onClick={() => scrollToId("contact")}
            className="text-xs text-zinc-600 hover:text-[#4169E1] transition-colors duration-300 text-left sm:text-right"
          >
            contact@hpvcjackson.org &middot; (769) 208-6710
          </button>
        </div>
      </div>
    </footer>
  );
}
